export default __webpack_public_path__ + "static/media/NDL_42.b3c089d4.png";